const popupInitialState = {
  show: '',
  data: null,
};

export default popupInitialState;
